import styled from 'styled-components';

export const ShareSocialListWrapper = styled.div`
  height: 100%;
`;

export const PreCodeEmbed = styled.pre`
  background-color: #262626;
  padding: 11px;
  white-space: break-spaces;
  font-size: 12px;
  border-radius: 3px;
  word-break: break-all;
`

export const SocialItemsWrapper = styled.div`
  display: flex;
  gap: 32px;
  align-items: center;
`

export const SocialItem = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 10px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  img {
    width: 32px;
  }
`
